module.exports = __webpack_public_path__ + "img/008.53b83863.jpg";